/** Canonical Drive lane grid placement (design spec + mock v2). */

export type DriveLaneGridKey =
  | 'strategy'
  | 'resources'
  | 'finance'
  | 'customers'
  | 'supply'
  | 'delivery'
  | 'other';

export const DRIVE_CANONICAL_STATE_ORDER = [
  'identified',
  'defined',
  'created',
  'active',
  'posted',
] as const;

export type DriveCanonicalState = (typeof DRIVE_CANONICAL_STATE_ORDER)[number];

export const DRIVE_GRID_TEMPLATE_AREAS = `
  "strategy ."
  "resources ."
  "finance ."
  "customers delivery"
  "supply delivery"
`;

export function resolveLaneGridKey(name: string, id: string): DriveLaneGridKey {
  const n = `${name} ${id}`.toLowerCase();
  if (n.includes('strategy')) return 'strategy';
  if (n.includes('resource')) return 'resources';
  if (n.includes('finance')) return 'finance';
  if (n.includes('customer') || n.includes('demand')) return 'customers';
  if (n.includes('supply') || n.includes('product')) return 'supply';
  if (n.includes('deliver')) return 'delivery';
  return 'other';
}

export function laneSortRank(key: DriveLaneGridKey): number {
  const order: DriveLaneGridKey[] = [
    'strategy',
    'resources',
    'finance',
    'customers',
    'supply',
    'delivery',
    'other',
  ];
  const idx = order.indexOf(key);
  return idx >= 0 ? idx : 99;
}

export type DriveEntropyVisual = 'active' | 'dormant' | 'undefined';

export function entropyVisualClass(
  entropyClass?: 'computed' | 'dormant' | 'undefined'
): DriveEntropyVisual {
  if (entropyClass === 'computed') return 'active';
  if (entropyClass === 'dormant') return 'dormant';
  return 'undefined';
}
